import { CustomButton } from "components/buttons/custom_button";
import { CustomTextButton } from "components/buttons/custom_text_button";
import { FileNameSection } from "components/file_name_section";
import { InputFieldComponent } from "components/form/input_field";
import { FormContentSection } from "components/form_content_section";
import { TwoColumnSection } from "components/two_column_section";
import { Col, Form, Row } from "react-bootstrap";
import { chartIllustrationImg } from "utils/data";

export const SavePage = () => {
  const savedFiles = [
    "Report Name.xlss",
    "Report Name.xlss",
    "Report Name.xlss",
    "Report Name.xlss",
  ];
  return (
    <TwoColumnSection
      mainSectionClass="align-items-center justify-content-between"
      firstColumn={
        <FormContentSection title="Please Fil the form" className=" me-lg-4">
          <Form className="d-flex flex-column gap-3">
            {savedFiles.map((file, index) => (
              <div
                className="bg-light rounded-3 p-3 d-flex align-items-center gap-3"
                key={index}
              >
                <FileNameSection fileName={file} />
              </div>
            ))}

            <InputFieldComponent
              label="Name"
              placeholder="Type"
              className="bg-light mb-5"
              onChange={() => {}}
            />

            <Row className="g-3">
              <Col xs={6} lg={5}>
                <CustomButton className="btn-primary-gradient" value="Load" />
              </Col>
              <Col xs={6} lg={5}>
                <CustomButton variant="secondary" value="Duplicate" />
              </Col>
              <Col xs={12}>
                <CustomTextButton value="Delete" />
              </Col>
            </Row>
          </Form>
        </FormContentSection>
      }
      secondColumn={
        <>
          <img
            src={chartIllustrationImg}
            alt="Chart Illusrtation"
            className="img-fluid"
          />
        </>
      }
    />
  );
};
